import React, { Component } from 'react';
import './Login.css';
import { signIn, errorMessages } from '../../auth';
export default class Login extends Component {
  state = { email: '', password: '', error: '' };
  handleChange = e => {
    e.persist();
    const name = e.target.name;
    const value = e.target.value;
    this.setState(currentState => ({
      ...currentState,
      [name]: value
    }));
  };
  submit = () => {
    const { email, password } = this.state;
    signIn(email, password)
      .then(() => {
        window.location.reload();
      })
      .catch(err => {
        const message = errorMessages[err.code];
        if (message) {
          this.setState(currentState => ({
            ...currentState,
            error: message
          }));
        }
      });
  };

  render() {
    const { email, password, error } = this.state;
    return (
      <div className="Login">
        <div>
          <label>Email</label>
          <input
            required
            type="text"
            name="email"
            value={email}
            onChange={this.handleChange}
          />
        </div>
        <div>
          <label>Password</label>
          <input
            required
            type="password"
            name="password"
            value={password}
            onChange={this.handleChange}
          />
        </div>
        <div className="Login-submit">
          <button className="" onClick={this.submit}>
            Login
          </button>
        </div>
        {error.length ? <div className="Login-error">{error}</div> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.js